/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _transition = require("../utils/transition");
var _currentTimeMarker = _interopRequireDefault(require("./currentTimeMarker.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CurrentTimeMarker = function CurrentTimeMarker(_ref) {
  var offset = _ref.offset,
    length = _ref.length,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 2 : _ref$width,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _currentTimeMarker["default"] : _ref$theme,
    style = _ref.style,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? {} : _ref$animation,
    rtl = _ref.rtl;
  var transform = "translate".concat(vertical ? 'Y' : 'X', "(").concat(rtl ? -offset : offset, "px)");
  var _style = _objectSpread({
    width: vertical ? length : width,
    height: vertical ? width : length,
    transform: transform,
    WebkitTransform: transform,
    transition: (0, _transition.animationToTransition)(animation)
  }, style);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.currentTimeMarker,
    style: _style
  });
};
CurrentTimeMarker.propTypes = {
  /**
   * Animation settings deciding ```enabled```,
   * ```speed``` and ```type``` (e.g. linear, ease-out)
   */
  animation: _propTypes["default"].shape({
    disabled: _propTypes["default"].bool,
    speed: _propTypes["default"].number,
    type: _propTypes["default"].string
  }),
  /** The length of the marker */
  length: _propTypes["default"].number,
  /** Offset position */
  offset: _propTypes["default"].number,
  /** Right to left */
  rtl: _propTypes["default"].bool,
  /** Styles to be applied to the outer container div */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    currentTimeMarker: _propTypes["default"].string
  }),
  /** If the time marker should be layed out vertically */
  vertical: _propTypes["default"].bool,
  /** The thickness of the marker */
  width: _propTypes["default"].number
};
var _default = CurrentTimeMarker;
exports["default"] = _default;